// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Benefit, ExpenseType, Transaction } from '../../../@types';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormUploadDocs } from '../../forms/FormUploadDocs/FormUploadDocs';

// utils
import { formatCurrency } from '../../../utils/currency';

// props
export interface DialogUploadDocsTransactionProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	transaction: Transaction;
}

export const DialogUploadDocsTransaction = ({
	isOpen,
	onClose,
	onSuccess,
	transaction,
}: DialogUploadDocsTransactionProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	// vars
	const amount = formatCurrency({
		currency: transaction.currency,
		value: transaction.amount,
	});

	let subtitle: DialogActionsProps['subtitle'] = undefined;

	if (transaction.benefit && transaction.quantity) {
		subtitle = {
			children: `${transaction.quantity} ${(transaction.benefit as Benefit).name}`,
		};
	} else if (transaction.amount) {
		subtitle = {
			children: amount,
		};

		if (transaction.expenseType) {
			subtitle.children = `${amount} (${(transaction.expenseType as ExpenseType).name})`;
		}
	}

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('uploadDocuments'),
					form: 'form-upload-docs-transaction',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			alignItems="center"
			hasClose={true}
			IconCircleProps={{
				type: 'document',
			}}
			isOpen={isOpen}
			onClose={onClose}
			subtitle={subtitle}
			title={{
				children: t('uploadDocuments'),
			}}>
			<FormUploadDocs
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
				transaction={transaction}
			/>
		</DialogActions>
	);
};
